<div class="body_wrap dashboard_body">
  <!-- <div class="sticky-top sticky-offset">
    <div class="top_menu">
      <button mat-button class="d-md-none d-none"><img src="../../assets/images/menu.svg" /></button>
    </div>
  </div> -->
  <div class="dash_base">
    <div class="loadingMapFull" *ngIf="isLoadingDealList">
      <div class="flex_center fullHeight">
        <mat-spinner [diameter]="30" class="mr-3"></mat-spinner> Please wait while we load
      </div>
    </div>
  </div>
  <div class="mt-40">
    <div class="container">
      <div class="whiteWrap">
        <div class="titleWrap">
          <div class="row w-100">
            <div class="col-sm-12">
              <h4 class="mt-1">Rentals</h4>
            </div>
          </div>
        </div>
        <div class="wrap_body">
          <div class="mb-3 row">
            <div class="col-lg-12 mt-2">
              <div>
                <form [formGroup]="dealAnalysisFilterForm">
                  <div class="row">
                    <div class="col-6 col-md-3">
                      <mat-form-field>
                        <mat-label> Search </mat-label>
                        <input
                          matInput
                          autocomplete="off"
                          formControlName="searchDealField"
                          placeholder="Search Name"
                        />
                      </mat-form-field>
                    </div>

                    <div class="col-6 col-md-2">
                      <mat-form-field>
                        <mat-label>Sort By</mat-label>
                        <mat-select formControlName="ownedTypeField">
                          <mat-option value="">All</mat-option>
                          <mat-option value="true">Owned by me </mat-option>
                          <mat-option value="false">Shared with me</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>

                    <div class="col col-md-auto row align-items-center">
                      <button mat-stroked-button class="ml-2 primary" (click)="resetSearchField()">Reset</button>
                    </div>
                  </div>
                </form>
              </div>
              <div class="table_base">
                <div class="table-responsive table_wrap">
                  <table
                    mat-table
                    matSort
                    [dataSource]="tableDataSource"
                    multiTemplateDataRows
                    class="mat-elevation-z2"
                  >
                    <ng-container matColumnDef="address" class="text-left">
                      <th mat-sort-header mat-header-cell *matHeaderCellDef>Address</th>
                      <td mat-cell *matCellDef="let element">{{ element.address }}</td>
                    </ng-container>
                    <ng-container matColumnDef="name">
                      <th mat-header-cell *matHeaderCellDef>Name</th>
                      <td mat-cell *matCellDef="let element"></td>
                    </ng-container>
                    <ng-container matColumnDef="ownedBy">
                      <th mat-header-cell *matHeaderCellDef>Owned By</th>
                      <td mat-cell *matCellDef="let element"></td>
                    </ng-container>
                    <ng-container matColumnDef="updatedDate">
                      <th mat-header-cell *matHeaderCellDef>Last Saved Date</th>
                      <td mat-cell *matCellDef="let element">{{ element.lastSavedDate | simpleDate }}</td>
                    </ng-container>
                    <ng-container matColumnDef="action">
                      <th mat-header-cell *matHeaderCellDef>Actions</th>
                      <td mat-cell *matCellDef="let element">
                        <button
                          *ngIf="element.isOwned == 'true'"
                          class="delete mat-icon-button"
                          (click)="deleteDeal(element.PMXPropertyId, 'address')"
                        >
                          <mat-icon>delete</mat-icon>
                        </button>
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="expandedDetail">
                      <td
                        style="padding-right: 0px !important"
                        mat-cell
                        *matCellDef="let element"
                        [attr.colspan]="tableColumnList.length"
                      >
                        <div
                          class="example-element-detail"
                          [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'"
                        >
                          <table mat-table [dataSource]="element.deals" class="mat-elevation-z2 w-100">
                            <ng-container matColumnDef="address">
                              <th mat-header-cell *matHeaderCellDef></th>
                              <td mat-cell *matCellDef="let elem">{{ element.address }}</td>
                            </ng-container>
                            <ng-container matColumnDef="name">
                              <th mat-header-cell *matHeaderCellDef></th>
                              <td mat-cell *matCellDef="let elem">{{ elem.name }}</td>
                            </ng-container>
                            <ng-container matColumnDef="ownedBy">
                              <th mat-header-cell *matHeaderCellDef></th>
                              <td mat-cell *matCellDef="let elem">
                                {{ elem.isOwned == 'true' ? 'Me' : elem.ownedBy }}
                              </td>
                            </ng-container>
                            <ng-container matColumnDef="updatedDate">
                              <th mat-header-cell *matHeaderCellDef></th>
                              <td mat-cell *matCellDef="let elem">{{ elem.lastSavedDate | simpleDate }}</td>
                            </ng-container>
                            <ng-container matColumnDef="action">
                              <th mat-header-cell *matHeaderCellDef></th>
                              <td mat-cell *matCellDef="let elem">
                                <button
                                  *ngIf="elem.isOwned == 'true'"
                                  class="mat-icon-button"
                                  [matMenuTriggerFor]="menu"
                                  (click)="$event.stopPropagation()"
                                >
                                  <mat-icon>more_vert</mat-icon>
                                </button>
                                <mat-menu #menu="matMenu" class="matSmall" xPosition="before">
                                  <button
                                    *ngIf="elem.isOwned == 'true'"
                                    mat-menu-item
                                    (click)="openRenameDealDialog(elem)"
                                  >
                                    <mat-icon>edit</mat-icon><span>Rename</span>
                                  </button>
                                  <button
                                    *ngIf="elem.isOwned == 'true'"
                                    mat-menu-item
                                    (click)="deleteDeal(elem.id, 'deal')"
                                  >
                                    <mat-icon>delete</mat-icon><span>Delete</span>
                                  </button>
                                </mat-menu>
                              </td>
                            </ng-container>
                            <tr
                              mat-row
                              (click)="openDealAnalysisSheet(row)"
                              *matRowDef="let row; columns: tableColumnList"
                            ></tr>
                          </table>
                        </div>
                      </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="tableColumnList"></tr>
                    <tr
                      mat-row
                      *matRowDef="let element; columns: tableColumnList"
                      class="example-element-row"
                      [class.example-expanded-row]="expandedElement === element"
                      (click)="expandedElement = expandedElement === element ? null : element"
                    ></tr>
                    <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
                  </table>
                </div>

                <div class="flex_center w-100" *ngIf="!isLoadingDealList && !tableDataSourceCount">
                  <div class="notFound text-center noData">
                    <div>
                      <img class="img-fluid" width="60" src="~/../assets/images/notFound.svg" />
                      <h4>No Deals found</h4>
                    </div>
                  </div>
                </div>

                <mat-paginator [pageSizeOptions]="[10, 20]" showFirstLastButtons> </mat-paginator>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #editDealDialog>
  <div class="addGroupWrap">
    <h2 matDialogTitle class="text-center mb-1">Rename Deal</h2>
    <div mat-dialog-content>
      <form class="mt-3">
        <mat-form-field>
          <input
            matInput
            pattern="^[ A-Za-z0-9-_]*$"
            placeholder="Deal name"
            type="text"
            name="name"
            [(ngModel)]="newDealName"
            (keydown.enter)="(true)"
            autocomplete="off"
            #dealName="ngModel"
          />
        </mat-form-field>
        <mat-error *ngIf="isSubmit && this.existingDealName === this.newDealName" class="invalid-feedback">
          New and existing rental analysis name can't be same
        </mat-error>
        <mat-error *ngIf="dealName.errors && dealName.errors.pattern" class="invalid-feedback">
          Special Characters are not allowed
        </mat-error>
      </form>
    </div>
    <mat-dialog-actions>
      <div class="w-100 text-right">
        <button mat-button (click)="resetForm()">Cancel</button>
        <button
          class="ml-1"
          cdkFocusInitial
          mat-flat-button
          color="primary"
          (click)="renameDeal()"
          [disabled]="!newDealName"
        >
          Rename
        </button>
      </div>
    </mat-dialog-actions>
  </div>
</ng-template>
